<template>
  <div class="webdesign-left-nav" :class="isCollapse ? 'collapse-menu' : ''" :style="[getCheckColor, getNavBgInfo, navThemeObject]" v-if="styleTemp.topStyle && styleTemp.topStyle.layoutPos === 'left' && isAppenLi">
    <el-scrollbar>
      <div class="left-nav-top" v-if="styleTemp.topStyle.leftNavOpenUrl || styleTemp.topStyle.leftNavCloseUrl || topUseFun.includes('logo') || topUseFun.includes('name') || topUseFun.includes('subscript') ">
        <template v-if="styleTemp.topStyle.logoStyle === 'custom'">
          <template v-if="!isCollapse">
            <div class="left-nav-top-custom">
              <div class="left-nav-top-custom-title" v-if="topUseFun.includes('logo') || topUseFun.includes('name') || topUseFun.includes('subscript')">
                <div class="img" v-if="topUseFun.includes('logo')" :style="topUseFun.includes('name') || topUseFun.includes('subscript') ? '' : 'width: 100%;height: auto'">
                  <img :src="getLogoImg" />
                </div>
                <div class="nav-top-title" v-if="topUseFun.includes('name') || topUseFun.includes('subscript')">
                  <div class="nav-top-title-name" v-if="topUseFun.includes('name')" :style="topLogoInfo.name && topLogoInfo.name.font">
                    {{ topLogoInfo.name && topLogoInfo.name.text }}
                  </div>
                  <div class="nav-top-title-tips" v-if="topUseFun.includes('subscript')" :style="[topLogoInfo.subscript && topLogoInfo.subscript.font, { background: 'transparent' }]">
                    {{ topLogoInfo.subscript && topLogoInfo.subscript.text }}
                  </div>
                </div>
              </div>
              <div class="left-nav-top-custom-slogan" v-if="topUseFun.includes('slogan')" :style="topLogoInfo.slogan && topLogoInfo.slogan.font">
                {{ topLogoInfo.slogan && topLogoInfo.slogan.text }}
              </div>
            </div>
          </template>
          <div v-else-if="isCollapse && styleTemp.topStyle.leftNavCloseUrl" class="left-nav-top-logo close-img">
            <img :src="$imgurl + styleTemp.topStyle.leftNavCloseUrl" alt="">
          </div>
        </template>
        <template v-else>
          <div v-if="isCollapse && styleTemp.topStyle.leftNavCloseUrl" class="left-nav-top-logo close-img">
            <img :src="$imgurl + styleTemp.topStyle.leftNavCloseUrl" alt="">
          </div>
          <div v-else-if="!isCollapse && styleTemp.topStyle.leftNavOpenUrl" class="left-nav-top-logo">
            <img :src="$imgurl + styleTemp.topStyle.leftNavOpenUrl" alt="">
          </div>
        </template>
      </div>
      <el-menu ref="leftNav" unique-opened :default-active="activeTotalMenu + ''" :active-text-color="styleTemp.overAllStyle.themeColor" class="left-menu" mode="vertical" :collapse="isCollapse">
        <template v-for="nav in leftNavList">
          <el-sub-menu popper-class="left-menu-pop-list" :class="{ 'is-ctitle-over-four': isCollapse && nav.subtitle && nav.subtitle.length >= 4 }" v-if="nav.lists.length !== 0" :key="nav.id" :index="nav.id + ''">
            <template #title>
              <div class="custom-content-nav" :style="nav.subtitle ? '' : 'custom-content-no-subtitle'" style="width: 100%;">
                <div class="custom-content-nav-img">
                  <template v-if="isObject(nav.iconName)">
                    <icon-module
                      v-if="isObject(nav.iconName)"
                      :config="(activeTotalMenu === nav.id || activeTopMenu === nav.id) && isCollapse ? (nav.highIconName || nav.iconName) : nav.iconName"
                    />
                  </template>
                </div>
                <div class="custom-content-nav-mask title-mask" v-if="isCollapse && (activeTotalMenu === nav.id || activeTopMenu === nav.id)"></div>
                <div class="custom-content-nav-title" :ref="`${nav.id}Title`" :style="getNavFontStyle" :title="nav.column">{{ nav.column }}</div>
                <div class="custom-content-nav-subtitle" :class="(activeTotalMenu === nav.id || activeTopMenu === nav.id) ? 'active-nav-subtitle' : ''" v-if="isCollapse && nav.subtitle" :style="{ color: getNavFontStyle.color }">{{ nav.subtitle.slice(0, 4) }}</div>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item v-for="cnav in nav.lists" :class="{ 'is-ctitle-over-four': isCollapse && cnav.subtitle && cnav.subtitle.length >= 4 }" :key="cnav.id" :index="cnav.id + ''">
                <div class="custom-content-nav" :class="[{
                  'nav-color-block': styleTemp.topStyle.navStyle === 'colorBlock' && activeTotalMenu === cnav.id
                }, cnav.subtitle ? '' : 'custom-content-no-subtitle']" :style="[getCheckColor, navThemeObject, isCollapse ? getNavBgInfo : {}]"  style="width: 100%;" @click.stop="handleNavClick(cnav)">
                  <div class="custom-content-nav-mask" v-if="activeTotalMenu === cnav.id"></div>
                  <div class="custom-content-nav-img">
                    <template v-if="isObject(cnav.iconName)">
                      <icon-module
                        v-if="isObject(cnav.iconName)"
                        :config="activeTotalMenu === cnav.id ? (cnav.highIconName || cnav.iconName) : cnav.iconName"
                      />
                    </template>
                  </div>
                  <div class="custom-content-nav-title" :style="[getNavFontStyle]" :title="cnav.column">{{ cnav.column }}</div>
                  <div class="custom-content-nav-subtitle" :class="(activeTotalMenu === nav.id || activeTopMenu === nav.id) ? 'active-nav-subtitle' : ''" v-if="isCollapse && cnav.subtitle" :style="{ color: getNavFontStyle.color }">{{ cnav.subtitle.slice(0, 4) }}</div>
                </div>
              </el-menu-item>
            </el-menu-item-group>
          </el-sub-menu>
          <template v-else>
            <el-menu-item :key="nav.id" :index="nav.id + ''" :class="{ 'is-ctitle-over-four': isCollapse && nav.subtitle && nav.subtitle.length >= 4 }" @click="handleNavClick(nav)">
              <div class="custom-content-nav" :class="[{
                'nav-color-block': styleTemp.topStyle.navStyle === 'colorBlock' && activeTotalMenu === nav.id
              }, nav.subtitle ? '' : 'custom-content-no-subtitle']" style="width: 100%;">
                <div class="custom-content-nav-mask" :class="isCollapse ? 'title-mask' : ''" v-if="activeTotalMenu === nav.id"></div>
                <div class="custom-content-nav-img">
                  <template v-if="isObject(nav.iconName)">
                    <icon-module
                      v-if="isObject(nav.iconName)"
                      :config="activeTotalMenu === nav.id ? (nav.highIconName || nav.iconName) : nav.iconName"
                    />
                  </template>
                </div>
                <div class="custom-content-nav-title" :ref="`${nav.id}Title`" :style="getNavFontStyle" :title="nav.column">{{ nav.column }}</div>
                <div class="custom-content-nav-subtitle" :class="(activeTotalMenu === nav.id || activeTopMenu === nav.id) ? 'active-nav-subtitle' : ''" v-if="isCollapse && nav.subtitle" :style="{ color: getNavFontStyle.color }">{{ nav.subtitle.slice(0, 4) }}</div>
              </div>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import iconMixin from '@/components/common/icon/common.js'
export default {
  // 组件名称  顶部导航栏 左侧模式
  name: 'topLeftNav',
  mixins: [iconMixin],
  // 组件参数 接收来自父组件的数据
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
    activeTotalMenu: {
      type: Number,
      default: 0,
    },
    activeTopMenu: {
      type: Number,
      default: 0,
    },
    styleTemp: {
      type: Object,
      default: () => { },
    },
    leftNavList: {
      type: Array,
      default: () => [],
    },
    isAppenLi: {
      type: Boolean,
      default: false,
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {}
  },
  // 计算属性
  computed: {
    getCheckColor () {
      const checkColor = this.styleTemp.topStyle.checkColor
      const custom = this.styleTemp.topStyle.checkCustomColor
      const theme = this.styleTemp.overAllStyle.themeColor
      const obj = {
        white: '#fff',
        theme,
        custom
      }
      return {
        '--check-text-color': obj[checkColor]
      }
    },
    getNavBgInfo () {
      const bgInfo = this.styleTemp.topStyle.backGroundInfo
      const radio = bgInfo.radio
      const img = bgInfo.imageUrl
      if (radio === 'color') {
        return {
          background: bgInfo.color
        }
      } else if (radio === 'image') {
        const obj = {
          backgroundImage: `url('${this.$imgurl + img}')`,
        }
        if (this.styleTemp.topStyle.bgImgLayout === 'cover') {
          obj.backgroundSize = 'cover'
          obj.backgroundRepeat = 'no-repeat'
          obj.backgroundPosition = 'center center'
        }
        return obj
      } else {
        return {
          background: 'white'
        }
      }
    },
    topLogoInfo() {
      if (!this.styleTemp.topContentInfo) return {}
      return this.styleTemp.topContentInfo.list.logo.list || {}
    },
    getLogoImg () {
      const url = this.topLogoInfo.img && this.topLogoInfo.img.url
      if (url && url.includes('/confiles')) {
        return this.$imgurl + url
      } else {
        return url
      }
    },
    topUseFun () {
      return this.styleTemp.topStyle.useFun || []
    },
    getNavFontStyle () {
      if (!this.styleTemp.topContentInfo) return {}
      const style = this.styleTemp.topContentInfo.list.navbar.font
      return style
    },
    navThemeObject() {
      let themeColor = '#4e86ff'
      const { navColor, navStyle, navCustomColor } = this.styleTemp.topStyle
      if (navColor === 'theme') {
        themeColor = this.themeColor
      } else if (navColor === 'custom') {
        themeColor = navCustomColor
      } else {
        if (navStyle === 'colorBlock' || navStyle === undefined) {
            themeColor = '#3333333d'
        } else {
            themeColor = 'white'
        }
      }
      return {
        "--navtheme-color": themeColor,
      }
    },
    themeColor() {
      return this.styleTemp.overAllStyle.themeColor
    },
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    handleNavClick(nav) {
      this.$emit('handleNavClick', nav)
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep.webdesign-left-nav {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  $navtheme-color: var(--navtheme-color);
  $theme-color: var(--main-color);
  $check-text-color: var(--check-text-color);
  .left-nav-top {
    margin: 20px 0 16px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    &-custom {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      &-title {
        display: flex;
        justify-content: center;
        .img {
          height: 40px;
          width: 40px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .nav-top-title {
          width: 175px;
          margin-left: 5px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
            line-height: normal;
          }
          &-tips {
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: normal;
          }
        }
      }
      &-slogan {
        width: 220px;
        min-height: 20px;
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        line-height: normal;
      }
    }
    .close-img {
      width: 40px;
    }
    &-logo {
      width: 224px;
      img {
        width: 100%;
      }
    }
  }
  
  .left-nav-collapse {
    position: absolute;
    right: -78px;
    top: 24px;
    z-index: 99;
    height: 26px;
    padding-right: 32px;
    border-right: solid 1px #F0EFF2;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .icon-a-zhankai2 {
      font-size: 18px;
      color: #000000;
      cursor: pointer;
      display: inline-block;
      transition: .3s;
    }
    .rotate {
      transform: rotate(180deg);
    }
  }

  .el-menu--collapse.left-menu {
    overflow: hidden;
    .el-menu-item {
      padding-left: 20px !important;
    }
    .el-sub-menu__title {
      padding-left: 20px !important;
    }
  }

  .el-menu {
    background-color: transparent;
    border-right: none;
  }

  .left-menu {
    // height: 100%;
    flex: 1;
    .el-menu-item {
      // 只有一级的菜单
      padding-left: 30px !important;
      padding-right: 17px !important;
      height: 65px;
    }

    .el-menu-item-group__title {
      padding: 0 !important;
    }
    .el-sub-menu__title {
      padding-left: 30px !important;
      padding-right: 17px !important;
      height: 65px;
      line-height: 55px;
      color: $navtheme-color !important;
    }

    .el-menu-item-group {
      .el-menu-item {
        height: 50px;
      }
    }

    .el-menu-item {
      .custom-content-nav-title {
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .is-active.el-menu-item {
      .nav-color-block {
        // 色块
        .custom-content-nav-mask {
          display: block !important;
        }
        .custom-content-nav-title {
          color: $check-text-color !important;
        }
      }
      .custom-content-nav-title {
        color: $check-text-color !important;
      }
    }
    .custom-content-nav {
      display: flex;
      align-items: center;
      position: relative;
      background-color: transparent;
      height: 100%;
      width: 100%;
      &-mask {
        display: none;
        left: -15px;
        top: 50%;
        transform: translateY(-50%);
        width: 218px;
        height: 40px;
        position: absolute;
        border-radius: 4px;
        background-color: $navtheme-color;
        z-index: 0;
      }

      .title-mask {
        left: -30px;
        display: inline-block;
      }

      &-img {
        width: 25px;
        height: 25px;
        margin-right: 20px;
        flex-shrink: 0;
        z-index: 2;
        * {
          vertical-align: top;
        }
      }
      &-title {
        font-weight: 400;
        font-size: 18px;
        z-index: 2;
        color: #333;
      }
    }
    .el-menu-item:hover,
    .el-sub-menu__title:hover,
    .el-sub-menu__title:focus,
    .el-menu-item:focus {
      background: none !important;
    }
  }
  .left-menu:not(.el-menu--collapse) {
    width: 240px;
  }
}

::v-deep.collapse-menu {
  .left-menu {
    .el-menu-item {
      height: 65px !important;
    }
    .el-sub-menu__title {
      height: 65px !important;
      line-height: 65px !important;
    }
    .active-nav-subtitle {
      color: var(--check-text-color) !important;
    }
    // .is-active.el-menu-item {
    //   .custom-content-nav-subtitle {
    //     color: var(--check-text-color) !important;
    //   }
    // }
    // .el-sub-menu.is-active {
    //   .el-sub-menu__title {
    //     .custom-content-nav-subtitle {
    //       color: var(--check-text-color) !important;
    //     }
    //   }
    // }
    .custom-content-no-subtitle.custom-content-nav{
      align-items: center !important;
    }
    .is-ctitle-over-four {
      height: 70px !important;
      .custom-content-nav {
        width: 100%;
        .custom-content-nav-mask {
          height: 70px !important;
        }
        &-subtitle {
          height: 34px;
          width: 28px;
          color: #FFFFFF;
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
          white-space: initial;
          overflow: initial;
          text-overflow: initial;
        }
      }
    }
    .custom-content-nav {
      position: relative;
      align-items: flex-start !important;
      padding: 7px 0;
      box-sizing: border-box;
      &-subtitle {
        position: absolute;
        left: 13px;
        transform: translateX(-50%);
        bottom: 0;
        height: 30px;
        width: 42px;
        text-align: center;
        font-size: 14px;
        line-height: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .custom-content-nav-mask {
        height: 60px !important;
      }
    }
  }
}
</style>
